<template>
   <div class="pagination justify-content-md-end justify-content-center">
    <div class="page">
      <a href="#" class="page-nav" @click="changePage(1)">
        <i class="icon-angle-double-left"></i>
      </a>
    </div>
    <div class="page" @click="changePage(currentPage - 1)">
      <a href="#" class="page-nav">
        <i class="icon-angle-left"></i>
      </a>
    </div>
    <div
      class="page"
      v-for="(page, index) in pages"
      :key="`page-${page}(${index})`"
    >
      <a
        href="#"
        class="page-item"
        :class="{active: currentPage === page}"
        v-if="page !== '...'"
        @click="changePage(page)" disabled
      >{{page}}</a>
      <a
        href="#"
        class="btn disabled"
        v-else
        disabled
      >{{page}}</a>
    </div>
    <div class="page" @click="changePage(currentPage + 1)">
      <a href="#" class="page-nav">
        <i class="icon-angle-right"></i>
      </a>
    </div>
    <div class="page">
      <a href="#" class="page-nav" @click="changePage(totalPages)">
        <i class="icon-angle-double-right"></i>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pages: {
      type: Array,
      default: []
    },
    currentPage: {
      type: Number,
      dafault: 1
    },
    totalPages: {
      type: Number,
      dafault: 0
    }
  },
  methods: {
    getRange(start, end) {
      return Array(end - start + 1)
        .fill()
        .map((_, i) => i + start)
    },

    pagination(currentPage, totalPages) {
      let delta
      if (totalPages <= 7) {
        delta = 7
      } else {
        delta = currentPage > 4 && currentPage < totalPages - 3 ? 2 : 4
      }

      const range = {
        start: Math.round(currentPage - delta / 2),
        end: Math.round(currentPage + delta / 2)
      }

      if (range.start - 1 === 1 || range.end + 1 === totalPages) {
        range.start += 1
        range.end += 1
      }

      let allPages =
        currentPage > delta
          ? this.getRange(Math.min(range.start, totalPages - delta), Math.min(range.end, totalPages))
          : this.getRange(1, Math.min(totalPages, delta + 1))

      const withDots = (value, pair) => (allPages.length + 1 !== totalPages ? pair : [value])

      if (allPages[0] !== 1) {
        allPages = withDots(1, [1, '...']).concat(allPages)
      }

      if (allPages[allPages.length - 1] < totalPages) {
        allPages = allPages.concat(withDots(totalPages, ['...', totalPages]))
      }

      return allPages
    },

    changePage(page) {
      this.$emit('update:changePage', page);
    },

    paginate(page, currentPage, totalItems, itemsPerPage, shouldChangePage = true, onChangePage = () => {}) {
      const totalPages = Math.ceil(totalItems / itemsPerPage);

      if (page < 1 || totalPages === 0) {
        page = 1;
      } else if (totalPages > 0 && page > totalPages) {
        page = totalPages;
      }

      const pages = this.pagination(page, totalPages);

      if (currentPage !== page && shouldChangePage) {
        onChangePage(page);
      }

      return [totalPages, pages, page]
    },
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue